import { isMobileOrTablet } from '../../../utils/helpers/mediaQueries';
import { WizardModeE, WizardTypeE } from './../models';

export const getHeaderTitle = (mode: WizardModeE, type: WizardTypeE) => {
    let title = '';

    switch (mode) {
        case WizardModeE.Create: return `Create a new ${type}`;
        case WizardModeE.Edit: return isMobileOrTablet()
            ? `Edit ${type}`
            : `Edit ${type} ${type === WizardTypeE.Delivery ? ` of the campaign ` : ''}`;
        case WizardModeE.Clone: return `Copy existing ${type}`;
    }

    return title;
};